// compare locale doesn't support < IE11
// apparantly some users use IE11 compatibility mode which is IE10
export const sortStrings = (_a, _b) => {
  const a = _a.name.toLowerCase();
  const b = _b.name.toLowerCase();

  if (a < b) { return -1; }
  if (a > b) { return 1; }
  return 0;
};
